<template>
    <FormSection
        title="Patient Representative Coordination"
        type="his-section"
        :full-height="false"
        :application-id="Number(application)"
    >
        <template #content>
            <div class="col col-12">
                <section class="col py-3 px-4 g-0">
                    <div v-for="option of Options" :key="`${option.value}-${option.label}`">
                        <div class="form-check d-flex pb-1 col-12">
                            <input
                                type="checkbox"
                                class="form-check-input"
                                :id="`${option.value}-${option.label}`"
                                :value="option.value"
                                :checked="option.value === referral.Contacts.PatientRepresentative"
                                @change="handlePatientRepresentative(option.value)"
                            />
                            <label class="form-check-label ms-1 col-12" :for="`${option.value}-${option.label}`">
                                {{ option.label }}
                            </label>
                        </div>
                        <div
                            class="mt-2 mb-2 ms-3"
                            v-if="referral.Contacts.PatientRepresentative === 2 && option.value === 2"
                        >
                            <div v-for="data of LegalReprentativeOptions" :key="`${data.value}-${data.label}`">
                                <div class="form-check d-flex pb-1 col-12">
                                    <input
                                        type="radio"
                                        class="form-check-input"
                                        :id="`${data.value}-${data.label}`"
                                        :value="data.value"
                                        :checked="data.value === referral.Contacts.LegalRepresentative"
                                        @change="handleLegalRepresentative(data.value)"
                                    />
                                    <label class="form-check-label ms-1 col-12" :for="`${data.value}-${data.label}`">
                                        {{ data.label }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div
                            class="mt-2 mb-2 ms-3"
                            v-if="referral.Contacts.PatientRepresentative === 4 && option.value === 4"
                        >
                            <div
                                v-for="data of PatientSelectedRepresentativeOptions"
                                :key="`${data.value}-${data.label}`"
                            >
                                <div class="form-check d-flex pb-1 col-12">
                                    <input
                                        type="radio"
                                        class="form-check-input"
                                        :id="`${data.value}-${data.label}`"
                                        :value="data.value"
                                        :checked="data.value === referral.Contacts.PatientSelectedRepresentative"
                                        @change="handlePatientSelectedRepresentative(data.value)"
                                    />
                                    <label class="form-check-label ms-1 col-12" :for="`${data.value}-${data.label}`">
                                        {{ data.label }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div
                            class="mt-2 mb-2 ms-3"
                            v-if="referral.Contacts.PatientRepresentative === 5 && option.value === 5"
                        >
                            <div
                                v-for="data of LegalRepresentativeNotInAgreementOptions"
                                :key="`${data.value}-${data.label}`"
                            >
                                <div class="form-check d-flex pb-1 col-12">
                                    <input
                                        type="radio"
                                        class="form-check-input"
                                        :id="`${data.value}-${data.label}`"
                                        :value="data.value"
                                        :checked="data.value === referral.Contacts.LegalRepresentativeNotInAgreement"
                                        @change="handleNotInAgreement(data.value)"
                                    />
                                    <label class="form-check-label ms-1 col-12" :for="`${data.value}-${data.label}`">
                                        {{ data.label }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./PatientRepresentativeCordination.ts"></script>
